import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { catchError, throwError, forkJoin } from 'rxjs';
import { ALLOWED_REQUEST_URL } from '../../domain/constants/allowed-request-url.const';
import { B2cAuthenticationUseCaseService } from '../../features/authentication/aplication/b2c-authentication-use-case.service';
import { ToastService, ToastType } from 'cve-ui';
import { TranslateService } from '@ngx-translate/core';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const authToken = localStorage.getItem('token') || '';
    const authApiService = inject(B2cAuthenticationUseCaseService);
    const toastService = inject(ToastService);
    const injector = inject(Injector);
    if (checkUrlAllowed(req)) {
        req = req.clone({
            headers: req.headers.append('Authorization', `Bearer ${authToken}`),
        });
    }
    if (req.url.includes(MICROSERVICES.b2c)) {
        req = req.clone({
            headers: req.headers.append('Ocp-Apim-Subscription-Key', environment.RUC_HEADER),
        });
    }

    return next(req).pipe(
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                const translate = injector.get(TranslateService);

                forkJoin({
                    title: translate.get('shared.toast.session_expired.title'),
                    label: translate.get('shared.toast.session_expired.label'),
                }).subscribe(({ title, label }) => {
                    toastService.show({
                        type: ToastType.error,
                        title,
                        label,
                    });
                });
                
                authApiService.logout();
            }
            return throwError(() => error);
        })
    );
}

function checkUrlAllowed(request: HttpRequest<unknown>) {
    return ALLOWED_REQUEST_URL.some((url) => request.url.includes(url));
}
